<script setup lang="ts">
import isStoryblokContentForWeb from "~/utils/isStoryblokContentForWeb";

definePageMeta({
  ssr: true,
  middleware: ["storyblok-preview-redirect", "cache-control-server"],
});

const { data: story, suspense } = useStoryblokQueryWithBridge({
  folderPath: "pages",
  suspense: true,
});

watch(
  story,
  async (newStoryData) => {
    if (newStoryData === undefined) {
      // means it's still loading
      return;
    }

    if (
      newStoryData === null ||
      (newStoryData.content &&
        !isStoryblokContentForWeb(newStoryData.content?.showOn))
    ) {
      throw createError({
        statusCode: 404,
        message: "Page not found",
      });
    }
  },
  { immediate: true, flush: "post" },
);

onServerPrefetch(async () => {
  await suspense();
});
const metaTags = computed(() => story.value?.content?.metaTags);
</script>

<template>
  <div>
    <LayoutMetaTags
      v-if="metaTags"
      :meta-tags="metaTags"
    />
    <StoryblokComponent
      v-if="story && isStoryblokContentForWeb(story.content?.showOn)"
      :blok="story.content"
      class="page-container"
    />
  </div>
</template>

<style lang="postcss">
.page-container > .block-viewport-container {
  @apply site-viewport-container;
}
</style>
